// Malayalam translations
export const ml: Record<string, string> = {
  'menu.dashboard': 'ഡാഷ്‌ബോർഡ്',
  'menu.customers': 'ഉപഭോക്താക്കൾ',
  'menu.products': 'ഉൽപ്പന്നങ്ങൾ',
  'menu.users': 'ഉപയോക്താക്കൾ',
  'menu.settings': 'ക്രമീകരണങ്ങൾ',
  'menu.logout': 'പുറത്തുകടക്കുക',
  'dashboard.title': 'ഡാഷ്‌ബോർഡ്',
  'dashboard.newOrder': 'പുതിയ ഓർഡർ',
  'order.title': 'പുതിയ ഓർഡർ',
  'order.customer': 'ഉപഭോക്താവ്',
  'order.products': 'ഉൽപ്പന്നങ്ങൾ',
  'order.total': 'ആകെ',
  'users.title': 'ഉപയോക്താക്കൾ',
  'users.name': 'പേര്',
  'users.email': 'ഇമെയിൽ',
  'common.yes': 'ഉണ്ട്',
  'common.no': 'ഇല്ല',
  'common.cancel': 'റദ്ദാക്കുക',
  'common.save': 'സംരക്ഷിക്കുക',
  'common.search': 'തിരയുക',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ലോഗിൻ',
  'login.welcome': 'സ്വാഗതം, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ഇമെയിൽ',
  'signup.phone': 'ഫോൺ',
  'menu.reportsAndAccounting': 'റിപ്പോർട്ടുകളും അക്കൗണ്ടിംഗും',
  'menu.systemAndCommunication': 'സിസ്റ്റവും ആശയവിനിമയവും',
};